import * as sidesNavTypes from './sides-nav.types';

export const setStateSidesNavReducer = (prop, value) => (dispatch) => {
	dispatch({ type: sidesNavTypes.SET_STATE_SIDES_NAV, payload: { prop, value } });
};